
import React from 'react';
import { CheckCircle } from 'lucide-react';

export const SuccessHeader: React.FC = () => {
  return (
    <div className="text-center space-y-4">
      <div className="rounded-full bg-green-50 p-3 w-16 h-16 mx-auto">
        <CheckCircle className="h-10 w-10 text-green-500" />
      </div>
      <h1 className="text-4xl font-bold text-gray-900 tracking-tight">Application Submitted Successfully!</h1>
      <p className="text-xl text-gray-600">
        Thank you for trusting us with your PEO search. Our team will review your application thoroughly to ensure you get the best matches.
      </p>
    </div>
  );
};

